/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/dpp-pkp-kasek-susulan`;

    return await http.get(`${url}?${queryString(payload.params)}`).then(({ data }) => data);
  },

  async candidate({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/dpp-pkp-kasek-susulan/kandidat`;

    return await http.get(`${url}?${queryString(payload.params)}`).then(({ data }) => data);
  },

  downloadList({ rootState }, payloads) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/dpp-pkp-kasek-susulan/${payloads.url}?${queryString(
      payloads.params
    )}`;

    return Promise.resolve(url);
  },

  listActions({ rootState }, payloads) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/dpp-pkp-kasek-susulan/${payloads.endpoint}`;

    if (!payloads.upload) {
      return http.post(url, payloads.params);
    }

    return http.post(url, payloads.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
